import React, { useContext } from 'react'
import { ConnectorViewMappingContext } from './context/context'
import { putRequest } from '../../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../../context/global_context'

const DuplicateSvgGroup = ({ connectorViewId, reference }) => {
  const { connector_view } = useParams()
  const [state, dispatch] = useContext(ConnectorViewMappingContext)
  const [navState, navDispatch] = useContext(NavContext)

  const findElements = async (tempGroupIds, reference, group_ids) => {
    for (let index = 1; index < 1000; index++) {
      let key = `${reference}_${index}`
      if (![...group_ids, ...tempGroupIds].includes(key)) {
        return key
      }
    }
  }

  const getNewGroupIds = async (connector_svg, reference, group_ids) => {
    let tempGroupIds = []

    connector_svg.childNodes.forEach((main, index) => {
      main.childNodes.forEach(async (parent, parentIndex) => {
        if (parent.id === reference) {
          let tempChild = parent.cloneNode(true)
          let childId = await findElements(tempGroupIds, reference, group_ids)
          tempChild.id = childId
          main.insertBefore(tempChild, parent)
          tempGroupIds.push(childId)
        }
      })
    })

    return tempGroupIds
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    navDispatch({
      type: 'loader',
      data: {
        caption: `Creating Duplicated reference reference ${reference}`,
        showLoader: true,
      },
      notification: {},
    })

    //// Generate New Duplicated group ids for svg
    let group_ids = [...state?.connector_view?.group_ids]

    let connector_svg = document.getElementById('connector-view-og-svg-image')

    let tempGroupIds = await getNewGroupIds(connector_svg, reference, group_ids)

    let allGroupIds = [...group_ids, ...tempGroupIds]

    ////// Set newly created nodes into svg file and remove unwanted attributes //////
    let tempSVG = connector_svg.cloneNode(true)

    let svg_bg_images = tempSVG.querySelectorAll('image')
    svg_bg_images.forEach((image) => {
      image.remove()
    })
    tempSVG.removeAttribute('xmlns:xlink')
    tempSVG.removeAttribute('xmlns:ev')

    tempSVG.removeAttribute('height')
    tempSVG.removeAttribute('width')
    tempSVG.removeAttribute('style')

    tempSVG.setAttribute('viewbox', '0 0 3600 3300')
    tempSVG.setAttribute('height', '3300')
    tempSVG.setAttribute('width', '3600')

    ///// Parse newly added children svg to send in backend //////
    var s = new XMLSerializer()
    var svgData = s.serializeToString(tempSVG)

    var svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' })

    var file = new File([svgBlob], state?.connector_view?.svg_name, {
      type: 'image/svg+xml;charset=utf-8',
    })

    let formData = new FormData()
    formData.append('svg', file)
    allGroupIds.forEach((id) => {
      formData.append('references', id)
    })

    let res = await putRequest(
      `/api/connector_views/update_svg/${connector_view}/`,
      formData
    )

    navDispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: `Reference successfully created with ${tempGroupIds}`,
      },
    })

    ///// Set newly created group ids into list
    dispatch({
      type: 'connector_view',
      data: {
        ...state.connector_view,
        group_ids: allGroupIds,
      },
    })

    // Update newly duplicated element to UI to highlight
    setNewGroupIdsToSVGUi(tempGroupIds, reference)
  }

  const setNewGroupIdsToSVGUi = (tempGroupIds, reference) => {
    let connector_view_svg_img = document.getElementById(
      'connector-view-svg-image'
    )

    connector_view_svg_img.childNodes.forEach((main, index) => {
      main.childNodes.forEach(async (parent, parentIndex) => {
        parent.childNodes.forEach(async (child, childIndex) => {
          if (child.id === reference) {
            tempGroupIds.forEach((newChildId) => {
              let tempChild = child.cloneNode(true)
              tempChild.id = newChildId
              tempChild.childNodes.forEach((tempChildren) => {
                if (tempChildren.nodeName == 'text') {
                  tempChildren.textContent = newChildId
                }
              })
              parent.insertBefore(tempChild, child)
            })
          }
        })
      })
    })
  }

  return (
    <div>
      <form
        acceptCharset="UTF-8"
        className="w-full"
        method="post"
        onSubmit={(e) => onSubmit(e)}
      >
        <button
          type="submit"
          className="object-left cursor-pointer text-blue-500 underline group-hover:block hidden font-normal w-full px-2"
        >
          Duplicate
        </button>
      </form>
    </div>
  )
}

export default DuplicateSvgGroup
